<template>
  <h1
    class="mt-8 text-2xl text-center font-bold"
    :class="{
      'text-primary-0': isKids,
      'text-guardian-secondary-0': isGuardian,
      'text-pets-primary-1': isPets
    }"
  >
    <slot />
  </h1>
</template>

<script setup>
import { isKids, isGuardian, isPets } from '@/comp/AppType'
</script>
